import { render, staticRenderFns } from "./termManager.vue?vue&type=template&id=0c7431e4&scoped=true"
import script from "./termManager.vue?vue&type=script&lang=js"
export * from "./termManager.vue?vue&type=script&lang=js"
import style0 from "./termManager.vue?vue&type=style&index=0&id=0c7431e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7431e4",
  null
  
)

export default component.exports